import { APP_BASE_HREF } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { AudioRecordingService } from '@app/_core/services/audio-recording.service';
import { CampaignService } from '@app/_core/services/campaign.service';
import { FilesService } from '@app/_core/services/files.service';
import { SecurityService } from '@app/_core/services/security.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
@Component({
  selector: 'app-message-view',
  templateUrl: './message-view.component.html',
  styleUrls: ['./message-view.component.scss'],
})
export class MessageViewComponent implements OnInit, OnDestroy {
  @Output() previewMessagedetails: EventEmitter<any> = new EventEmitter();
  disablePreviewBtn: boolean = true;
  previewBtnText: string = 'Preview';
  messageSource: any = [];
  selectedMessageSource: any = {};
  promptFileName;
  promptFileNameText = '';
  promptFile;
  recordBtn;
  stopBtn;
  recordingStatus;
  hasAdminGrant;
  mediaRecorder;
  recordingStatusTimeout;
  promptID = null;
  viewReady = false;
  savingRecordingFileMessage: any = '';
  isRecording: any;
  recordedTime: any;
  savingAudioFileMessage: any = '';
  blobUrl: any;
  blobData: any;
  private audio: HTMLAudioElement;
  currUpload;
  addnewCampaignForm: FormGroup;
  fileUpload: boolean = false;
  recordbtn: boolean = false;
  stoprecordbtn: boolean = false;
  stopRecordingTimeout: any;

  @Input()
  label;
  @Input()
  isCampaign;
  @Input()
  hideLabel;
  @Input()
  hideFileName;

  @Output()
  fileUploadEvent = new EventEmitter<any>();
  constructor(
    @Inject(APP_BASE_HREF) public baseHref: string,
    private securityService: SecurityService,
    private campaignService: CampaignService,
    private sanitizer: DomSanitizer,
    private webStorageService: WebStorageService,
    private audioRecordingService: AudioRecordingService,
    private filesService: FilesService
  ) {
    this.audio = new Audio();
    // Audio

    this.audioRecordingService.recordingFailed().subscribe(() => (this.isRecording = false));
    this.audioRecordingService.getRecordedTime().subscribe(time => (this.recordedTime = time));
    this.audioRecordingService.getRecordedBlob().subscribe(data => {
      this.blobData = data;
      this.blobUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data.blob));
    });
  }

  ngOnInit(): void {
    this.isRecording = false;

    this.hasAdminGrant = this.securityService.validateGrant('Admin');
    this.messageSource = [
      { label: 'Upload File', value: 'uploadfile' },
      { label: 'Real-Time Recording', value: 'recording' },
    ];
    if (this.isCampaign) {
      this.messageSource.push({
        label: 'Text-to-Speech',
        value: 'texttospeech',
      });
      if (this.hasAdminGrant) {
        this.messageSource.push({ label: 'Custom API', value: 'customapi' });
      }
    }

    if (this.isCampaign) this.label = this.label + '*';

    this.selectedMessageSource = { value: '-1', label: 'Select one' };
  }

  ngOnDestroy(): void {
    this.stopRecordingTimeout && clearTimeout(this.stopRecordingTimeout);
  }

  modifyMessageSource(value) {
    // promptFile.element().accept = 'audio/wav';
    const sourceValue = this.selectedMessageSource.value.toLowerCase();
    //cls.controller().sourceUpdated(sourceValue);
    switch (sourceValue) {
      case 'uploadfile':
        //promptFile.visible(true);
        this.fileUpload = true;
        //promptFileName.text(promptFileNameText);
        //if (!this.hideFileName)
        // promptFileName.visible(true);
        //recordBtn.visible(false);
        //stopBtn.visible(false);
        //recordingStatus.visible(false);
        //this.fileUpload =true;
        //recordBtn.visible(false);
        //stopBtn.visible(false);
        //recordingStatus.visible(false);

        break;
      case 'recording':
        navigator.mediaDevices.getUserMedia({ audio: true }).then(
          stream => {
            this.mediaRecorder = new MediaRecorder(stream);
            //const mime = ['audio/wav', 'audio/mpeg', 'audio/webm', 'audio/ogg'].filter(MediaRecorder.isTypeSupported)[0];
            //this.mediaRecorder.mimeType = mime;
            this.mediaRecorder.ondataavailable = blob => {
              this.currUpload = new File([blob], this.getDownloadFileName(), {
                type: 'audio/wav',
              });
              this.saveFile();
            };
          },
          error => {
            console.error('Media Error', error);
          }
        );
        this.fileUpload = false;
        //promptFile.visible(false);
        //promptFileName.visible(false);
        this.recordbtn = true;
        this.stoprecordbtn = false;
        this.recordingStatus = true;
        break;
      default:
        this.fileUpload = false;
        //promptFileName.visible(false);
        this.recordbtn = false;
        this.stoprecordbtn = false;
        this.recordingStatus = false;
      /*promptFile.visible(false);
        promptFileName.visible(false);
        recordBtn.visible(false);
        stopBtn.visible(false);
        recordingStatus.visible(false);*/
    }
  }

  messageSourceUpload(file) {
    this.currUpload = file;
    if (typeof this.currUpload != 'undefined') this.saveFile();
  }

  startRecording() {
    this.savingRecordingFileMessage = '';
    if (this.isRecording) {
      this.audioRecordingService.startRecording();
      this.isRecording = false;
    }
  }

  previewMessage() {
    this.audio.play();
  }

  handleFileInput(event) {
    this.savingAudioFileMessage = 'Saving File';
    //let input = event.target.files[0];
    const input = event.target;
    if (!input.files?.length) {
      this.savingAudioFileMessage = '';
      return;
    }

    const file = input.files[0];
    const fileExt = event.target.files[0].name.split('.').pop();
    const path = (window.URL || window.webkitURL).createObjectURL(file);
   // console.log('path', path, fileExt);

    if (fileExt === 'wav' || fileExt === 'mp3') {
      this.loadAudio(path); // for preview
    }
    this.campaignService.uploadFile(file, fileExt, false, '').subscribe(response => {
     // console.log('saveFile', response);
      this.savingAudioFileMessage = 'File Saved';
      // this.addnewCampaignForm.patchValue({ messageDescription: response.Response.Data.URL });
      //console.log(this.addnewCampaignForm.value);
    });
  }

  abortRecording() {
    if (this.isRecording) {
      this.isRecording = false;
      this.audioRecordingService.abortRecording();
    }
  }

  stopRecording() {
    this.savingRecordingFileMessage = 'Saving file...';
    if (!this.isRecording) {
      this.audioRecordingService.stopRecording();
      this.isRecording = true;
      //this.download();

      this.stopRecordingTimeout = setTimeout(() => {
        this.loadAudio(this.blobUrl.changingThisBreaksApplicationSecurity);
        this.saveFile();
      }, 1000);
    }
  }

  saveFile() {
    this.campaignService.saveFile(this.blobData?.blob, false).subscribe(response => {
     // console.log('saveFile', response);
      //this.addnewCampaignForm.patchValue({messageDescription: response.Response.Data.URL});
      this.savingRecordingFileMessage = response.Response.Data.URL.split('/').pop();
      this.clearRecordedData();
    });
  }

  clearRecordedData() {
    this.blobUrl = null;
  }
  loadAudio(audioFilePath) {
   // console.log('loadAudio', audioFilePath);
   // console.log(this.audio);
    this.audio.src = audioFilePath;
    this.previewMessagedetails.emit({ audioFilePath });
    //console.log(audioFilePath);
    this.audio.load();
    this.disablePreviewBtn = false;
    this.previewBtnText = 'Preview';
  }

  onMessageSourceChange() {
    const sourceValue = this.selectedMessageSource.value;
   // console.log(sourceValue);

    if (sourceValue === 'recording') {
      this.isRecording = true;
    }
  }

  setPromptId(promptId) {
    this.promptID = promptId;
  }

  updateRequired(isRequired) {
    this.messageSource.required(isRequired);
  }

  updateMessageSourceOption(messageSourceValue, promptFileName) {
    this.messageSource = messageSourceValue;
    this.promptFileNameText = promptFileName;
    this.modifyMessageSource(promptFileName);
  }

  error() {
    //this.messageSource.labelTextColor("#ff0000");
  }

  getDownloadFileName() {
    const clientAbbr = this.webStorageService.getItemFromSessionStorage('company');
    let fileName = null;
    if (this.promptID != null) {
      fileName = 'Onvida_' + clientAbbr + '_Prompt' + this.promptID;
    } else {
      const timeStamp = new Date();
      let timeStampMonth: any = timeStamp.getMonth() + 1;
      timeStampMonth = timeStampMonth < 10 ? '0' + timeStampMonth : timeStampMonth;
      const timeStampDay = timeStamp.getDate() < 10 ? '0' + timeStamp.getDate() : timeStamp.getDate();
      fileName = 'Onvida_' + clientAbbr + '_' + timeStamp.getFullYear() + '-' + timeStampMonth + '-' + timeStampDay;
    }
    fileName += '.wav';
    return fileName;
  }
}
